import React, { useState, useEffect, useContext, useRef } from "react";
import axios from "axios";
import styled from "styled-components";
import { NotificationManager } from "react-notifications";
import Button from "@mui/material/Button";
import { makeStyles } from "@mui/styles";
import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";
import UserService from "services/UserService";
import { putMarketMeters } from "services/ConfigServices";
import { meters } from "variables/markets";
import { metersStatusData } from "variables/lists/markets";
import CustomSelect from "components/Input/CustomSelect.js";
import CustomSwitch from "components/Input/CustomSwitch.js";
import TextInput from "components/Input/TextInput.js";
import DateInput from "components/Input/DateInput.js";

const useStyles = makeStyles((theme) => ({
  root: {
    "& .MuiTextField-root": {
      margin: '16px',
      marginTop: "1rem",
      //width: "30ch",
    },
  },
  formControl: {
    margin: 8,
    width: "62ch",
  },
  gridList: {
    width: 330,
    height: 400,
    //marginLeft: "-2rem",
  },
  treeVisible: {
    display: "block",
  },
  treeHidden: {
    display: "none",
  },
  textField: {
    fontSize: "14px",
    fontFamily: '"Source Sans Pro",sans-serif',
    "& .MuiInputBase-input": {
      fontSize: "14px",
      fontFamily: '"Source Sans Pro",sans-serif',
    },
  },
  submitButton: {
    color: "#FFFFFF",
    backgroundColor: "#91C73C",
    fontWeight: "bold",
    display: "block",
    marginTop: "15px",
    marginRight: "auto",
    marginLeft: "0.5rem",
    width: "64.5ch",
    "&:hover": {
      backgroundColor: "#91C73C",
      boxShadow: "0px 11px 15px -7px rgb(0 0 0 / 20%)",
    },
  },
  submitButtonDisabled: {
    color: "#FFFFFF",
    backgroundColor: "#9798A0",
    fontWeight: "bold",
    display: "block",
    marginTop: "15px",
    marginRight: "auto",
    marginLeft: "0.5rem",
    width: "64.5ch",
  },
}));

const NoData = styled.p`
  font-size: 14px;
  font-weight: 600;
  margin-top: 20px;
  opacity: 1;
`;


function EditMeterDialog(props) {
  const { closeModal, refetch, marketmeter } = props;
  console.log(marketmeter);
  const [status, setStatus] = useState(marketmeter.parameters.status);
  const [datebegin, setDatebegin] = useState(marketmeter.parameters.datebegin);
  const [dateend, setDateend] = useState(marketmeter.parameters.dateend);
  const [description, setDescription] = useState(marketmeter.parameters.description);

  const handleStatusChange = (event) => { setStatus(event.target.value); };
  const handleDatebeginChange = (event) => { setDatebegin(event.target.value); };
  const handleDateendChange = (event) => { setDateend(event.target.value); };
  const handleDescriptionChange = (event) => { setDescription(event.target.value); };

  const [buttonDisabled, setButtonDisabled] = useState(true);
  useEffect(() => {
    if (!status)
      setButtonDisabled(true);
    else
      setButtonDisabled(false);
  }, [status]);

  const handleSubmit = () => {
    updateMarketMeters();
  };

  const updateMarketMeters = async (event) => {
    let updatedlist = [];
    let updatedmeter =
    {
      ...marketmeter,
      parameters: {
        ...marketmeter.parameters,
        status,
        datebegin,
        dateend,
        description,
      }
    }
    updatedlist.push(updatedmeter);
    await axios
      .put(
        putMarketMeters("update"),
        {
          meters: updatedlist,
        },
        {
          headers: {
            Authorization: `Bearer ${UserService.getToken()}`,
            'Content-Type': "application/json; charset=utf-8",
          },
        }
      )
      .then((res) => {
        if (res.status == 200) {
          setNotification("success", "Compteurs modifiés");
        } else setNotification("error", "Une erreur est survenue");
        closeModal();
        refetch();
      })
      .catch((error) => {
        setNotification("error", "Une erreur est survenue");
      });
  };

  const setNotification = (status, text) => {
    if (status === "success") {
      NotificationManager.success(text);
    } else {
      NotificationManager.error(text);
    }
  };
  const classes = useStyles();

  return (
    <>
      <form className={classes.root}>
        <GridContainer>
          <GridItem xs={12} sm={12} md={12} lg={12}>

            <div>
              <CustomSelect
                inputTitle={meters.status}
                selectValue={status}
                handleSelectValueChange={handleStatusChange}
                data={metersStatusData}
              />
            </div>

            <div>
              <DateInput
                inputTitle={meters.datebegin}
                dateInput={datebegin}
                handleDateInputChange={handleDatebeginChange}
              />
            </div>

            <div>
              <DateInput
                inputTitle={meters.dateend}
                dateInput={dateend}
                handleDateInputChange={handleDateendChange}
              />
            </div>

            <div>
              <TextInput
                inputTitle={meters.description}
                textInput={description}
                handleTextInputChange={handleDescriptionChange}
              />
            </div>
            <Button
              disabled={buttonDisabled}
              className={
                buttonDisabled
                  ? classes.submitButtonDisabled
                  : classes.submitButton
              }
              onClick={() => {
                handleSubmit();
              }}
            >
              Editer
            </Button>
          </GridItem>
        </GridContainer>
      </form>
    </>
  );
}

export default EditMeterDialog;
